module.exports = __webpack_public_path__ + "static/media/node2.162a021e.png";